<!--1. Main Component: ProductManagement.vue-->
<template>
    <div class="container-nzidoo">
        <NotFound v-if="error.code === 404" />
        <div v-else class="product-management">
            <LoadingSpinner v-if="loader" />

            <div v-else class="container-fluid-manege">
                <div class="row">
                    <!-- LEFT SIDE - Images Gallery -->
                    <div class="col-lg-5 col-md-6 px-0">
                        <ProductImageGallery :product="product" :is-favorite="isFavorite"
                            @toggle-favorite="toggleFavorite" @show-similar="showSimilarProducts" />

                        <ProductBreadcrumb :product="product" @show-similar="showSimilarProducts"
                            @show-similar-childs="showSimilarChildsProducts" />
                    </div>

                    <!-- RIGHT SIDE - Product Details -->
                    <div class="col-lg-7 col-md-6 pr-4">
                        <div class="product-details">
                            <ProductPriceSection :product="product" :sorted-offers="sortedOffers"
                                :price-lang="price_lang" :reserve-price-status="reservePriceReachedStatus"
                                @delete-auto-bid="deleteAutoBid" />

                            <UserBidStatusComp v-if="$route.name !== 'ProductManagement'" :product="product" />
                            <ProductActionSection v-if="$route.name !== 'ProductManagement'" :product="product"
                                :accepted-offers="acceptedOffers" :user="user" @place-bid="handlePlaceBid"
                                @buy-now="handleBuyNow" @buy-fixed="handleBuyFixed" @make-offer="show('make-offer')"
                                @make-auction="show('make-auction')" />

                            <ProductManagementActions v-if="$route.name === 'ProductManagement'" :product="product"
                                @open-manage="showManageMenu = true" @open-boost="openBoostMenu" />

                            <BoosterManagementModal v-if="$route.name === 'ProductManagement'" :product="product"
                                :plans="plans" :show-manage.sync="showManageMenu" :show-boost.sync="showBoostMenu"
                                @edit="editProduct" @toggle-pause="togglePause" @delete="deleteProduct"
                                @boost="confirmBoost" />


                            <ProductOffers v-if="sortedAuthOffers.length > 0" :offers="sortedAuthOffers" :user="user"
                                @format-price="formatPrice" />

                            <AuctionHistory v-if="product.sales_type === 'auction'" :bids="auctionBids"
                                :loading="loadingHistory" @format-price="formatPrice" />

                            <ProductOrders v-if="product.orders && product.orders.length > 0" :orders="product.orders"
                                @format-price="formatPrice" />

                            <ProductDescription :description="product.description" />

                            <ProductSpecifications :product="product" />

                            <div class="bottom-spacer"></div>
                        </div>
                    </div>
                </div>
            </div>
            <SellerInformationComp v-if="product?.user_id" :show-reviews="false" :product_id="product.id"
                :user_id="product.user_id" />


            <div v-if="$route.name !== 'ProductManagement'">
                <MakeAnOfferModal v-if="product && product.id" :conversation-id="product.conversation_id" :products="[{ product: product, quantity: 1 }]" />
                <MakeAnAuctionModal v-if="product && product.id" :product="product" @bid-sent="onBidSentFromModal" />
                <login-modal v-if="$route" :route="$route.name" />
            </div>

            <notifications class="custom-notifications mt-2" group="success" position="top center" />
            <notifications class="custom-notifications mt-2" group="error" position="top center" />
            <v-dialog />
        </div>
    </div>
</template>

<script>
// import config from "@/config.js";
import AlertService from "@/services/alertService";
import LoadingSpinner from "@/components/templates/LoadingSpinner.vue";
import SellerInformationComp from "@/components/user/SellerInformationComp.vue";
import helper from "@/services/helper";

import MakeAnOfferModal from "@/components/modals/MakeAnOfferModal.vue";
import MakeAnAuctionModal from "@/components/modals/MakeAnAuctionModal.vue";
import LoginModal from '@/components/modals/LoginModal.vue';

// New child components
import ProductImageGallery from '@/components/product-details/ProductImageGallery.vue';
import ProductBreadcrumb from '@/components/product-details/ProductBreadcrumb.vue';
import ProductPriceSection from '@/components/product-details/ProductPriceSection.vue';
import ProductActionSection from '@/components/product-details/ProductActionSection.vue';
import ProductOffers from '@/components/product-details/ProductOffers.vue';
import AuctionHistory from '@/components/product-details/AuctionHistory.vue';
import ProductOrders from '@/components/product-details/ProductOrders.vue';
import ProductDescription from '@/components/product-details/ProductDescription.vue';
import ProductSpecifications from '@/components/product-details/ProductSpecifications.vue';
import ProductManagementActions from '@/components/product-details/ProductManagementActions.vue';
import UserBidStatusComp from '@/components/product-details/UserBidStatusComp.vue';
import BoosterManagementModal from '@/components/modals/BoosterManagementModal.vue';


import NotFound from "@/views/errors/404.vue";
import Cookies from 'js-cookie';

export default {
    name: "ProductManagement",
    components: {
        SellerInformationComp,
        MakeAnOfferModal,
        MakeAnAuctionModal,
        LoginModal,
        LoadingSpinner,
        ProductImageGallery,
        ProductBreadcrumb,
        ProductPriceSection,
        ProductActionSection,
        ProductOffers,
        AuctionHistory,
        ProductOrders,
        ProductDescription,
        ProductSpecifications,
        ProductManagementActions,
        UserBidStatusComp,
        BoosterManagementModal,
        NotFound,
    },

    data() {
        return {
            loader: true,
            product: {},
            plans: [],
            error: [],
            isFavorite: false,
            auctionBids: [],
            loadingHistory: false,
            showManageMenu: false,
            showBoostMenu: false,
            price_lang: Cookies.get('price_lang')||'ar',
        };
    },

    async mounted() {
        await this.fetchProduct();
        if (this.$route.name=='ProductManagement') {
            this.loadPlans();
        }
    },

    computed: {
        user: {
            get() {
                return this.$store.state.user;
            },
            set(user) {
                this.$store.commit("setUser", { user: user });
            },
        },

        computedMinFixedPrice() {
            const fixed=Number(this.product?.fixed_price??Infinity);
            const bestOffer=Number(this.sortedOffers?.[0]?.price??Infinity);
            return Math.min(fixed, bestOffer);
        },

        sortedAuthOffers() {
            const rank=status => {
                if (status===1) return 0;
                if (status===0) return 2;
                return 1;
            };

            return this.product.auth_offers
                .slice()
                .sort((a, b) =>
                    rank(a.status)-rank(b.status)||
                    new Date(b.created_at)-new Date(a.created_at)||
                    b.price-a.price
                );
        },
        sortedOffers() {
            const rank=status => {
                if (status===1) return 0;
                if (status===0) return 2;
                return 1;
            };

            return this.product.offers
                .slice()
                .sort((a, b) =>
                    rank(a.status)-rank(b.status)||
                    new Date(b.created_at)-new Date(a.created_at)||
                    b.price-a.price
                );
        },

        reservePriceReachedStatus() {
            return this.product.best_bid?.price<this.product.lowest_price
                ? this.$t('sentence.reserve_price_not_met')
                :this.$t('sentence.reserve_price_met');
        },

        acceptedOffers() {
            const offers=this.product.offers
                .filter(offer => offer.status==1&&offer.user_id===this.user.id);

            if (!offers.length) return null;

            return offers.reduce((lowest, offer) =>
                offer.price<lowest.price? offer:lowest
            );
        },

    },

    methods: {
        async fetchProduct() {
            try {
                this.loader=true;
                const productId=this.$route.params.id;
                const { data }=await this.$axios.get(`product/get/${productId}`);
                this.product=data;
                if (this.product.user_id===this.user.id) {
                    this.$router.push({ name: "ProductManagement", params: { id: this.product.id } });
                }
                this.auctionBids=[...(data.bids||[])].sort(
                    (a, b) => b.price-a.price
                );


                this.isFavorite=this.product.is_favorited;
            } catch (error) {
                console.error("Error fetching product:", error.response.data.message);
                this.error=error.response.data;
            } finally {
                this.loader=false;
            }
        },

        formatPrice: helper.formatPrice,

        async toggleFavorite() {
            try {
                if (!this.isLoggedIn()) {
                    this.$router.push('/login');
                    return;
                }
                const res=await this.$axios.post(`favorites/toggle/${this.product.id}`);
                this.isFavorite=res.data.data.status;
            } catch (error) {
                console.error('Failed to toggle favorite:', error);
            }
        },

        showSimilarProducts() {
            this.$router.push(`/products-filters?categories=${this.product.category.parent_id}`);
        },

        showSimilarChildsProducts() {
            this.$router.push(`/products-filters?categories=${this.product.category.id}`);
        },

        show(modalName) {
            this.$modal.show(modalName);
        },

        async onBidSentFromModal() {
            try {
                await this.fetchProduct();
            } catch (err) {
                console.error('Failed to refresh product after bid:', err);
            }
        },

        handlePlaceBid({ price, quantity }) {
            this.showPopUpConfirmation(2, { price, quantity });
        },

        handleBuyNow({ productId, quantity }) {
            this.showPopUpConfirmation(1, productId, quantity);
        },

        handleBuyFixed({ productId, quantity }) {
            this.showPopUpConfirmation(1, productId, quantity);
        },

        showPopUpConfirmation(id, productId=null) {
            var self=this;

            if (undefined===this.user) {
                self.show("login-user");
                return;
            }

            if (this.user.id===this.product.user.id) {
                self.$notify({
                    group: "error",
                    title: "Erreur !",
                    type: "error",
                    text: self.$t("api.cannot_buy_own_product"),
                }, 100000);
                return;
            }

            this.$modal.show("dialog", {
                title: "Confirmation",
                text: id===2
                    ? "Vous allez surenchérir sur ce produit."
                    :"Veuillez confimer votre achat",
                buttons: [
                    {
                        title: "Cancel",
                        handler: () => {
                            self.$modal.hide("dialog");
                            return false;
                        },
                    },
                    {
                        title: "Confirmer",
                        handler: () => {
                            self.$modal.hide("dialog");
                            if (id===2) {
                                self.placeBid(id);
                            } else {
                                if (!self.isLoggedIn) {
                                    self.show("login-user");
                                } else {
                                    self.$router.push({
                                        name: "checkoutOrder",
                                        params: {
                                            type: "product",
                                            id: productId,
                                            quantity: self.quantity,
                                        },
                                    });
                                }
                            }
                        },
                    },
                ],
            });
        },

        async deleteAutoBid(autoBidId) {
            if (!this.isLoggedIn()) {
                this.$router.push('/login');
                return;
            }

            try {
                const confirmed=await AlertService.confirm({
                    title: this.$t('sentence.confirmDeleteAutoBid'),
                });

                if (!confirmed) return;

                const { data }=await this.$axios.patch(`bids/deleteAutoBid/${autoBidId}`);

                if (data.success!==false) {
                    this.product.last_auto_bid=null;
                    AlertService.success(
                        this.$t('sentence.autoBidDeleted')
                    );
                    await this.fetchProduct();
                }
            } catch (error) {
                console.error('Error deleting AutoBid:', error);
                AlertService.error(this.$t('sentence.deleteAutoBidError'));
            }
        },

        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },

        async loadPlans() {
            try {
                const res=await this.$axios.get("/get-booster-plans");
                this.plans=Array.isArray(res.data.data)
                    ? res.data.data
                    :Object.values(res.data.data);
            } catch (err) {
                console.error("Error loading booster plans:", err);
            }
        },

        editProduct() {
            this.$router.push({
                name: 'ProductEdit',
                params: { id: this.product.id }
            });
        },

        async togglePause() {
            try {
                const confirmed=await AlertService.confirm({
                    title: this.product.paused
                        ? this.$t('sentence.confirmUnpause')
                        :this.$t('sentence.confirmPause'),
                });

                if (!confirmed) return;

                const { data }=await this.$axios.post(`product/toggle-pause/${this.product.id}`);

                if (data.success) {
                    this.product.paused=data.paused_at;
                    AlertService.success(
                        data.status==='paused'
                            ? this.$t('sentence.productPaused')
                            :this.$t('sentence.productUnpaused')
                    );
                    this.fetchProduct();
                }
            } catch (error) {
                console.error("Error toggling pause:", error);
                AlertService.error(this.$t('sentence.serverError'));
            }
        },

        async deleteProduct() {
            try {
                const confirmed=await AlertService.confirm({
                    title: this.$t('sentence.confirmDelete'),
                });

                if (!confirmed) return;

                const response=await this.$axios.delete(`product/${this.product.id}`);

                if (response?.data?.success) {
                    AlertService.success(
                        this.$t('sentence.productDeleted')
                    );
                    this.$router.push({ name: 'MyProducts' });
                }
            } catch (error) {
                console.error("Error deleting product:", error);
                AlertService.error(this.$t('sentence.deleteError'));
            }
        },

        async confirmBoost({ planIds, paymentType }) {

            if (!Array.isArray(planIds)||!planIds.length) return;

            const plans=this.plans.filter(p => planIds.includes(p.id));
            if (!plans.length) return;

            const planNames=plans.map(p => p.name).join(', ');

            try {
                const confirmed=await AlertService.confirm({
                    title: this.$t('boost.confirmTitle'),
                    text: `${this.$t('boost.confirmText')} : ${planNames} ?`
                });

                if (!confirmed) return;

                const response=await this.$axios.post('/booster/purchase', {
                    product_id: this.product.id,
                    plan_ids: planIds,
                    payment_method_id: paymentType
                });

                if (response.data.success) {
                    AlertService.success(
                        this.$t('boost.success')
                    );
                    await this.fetchProduct();
                }

            } catch (error) {
                console.error('Error boosting product:', error);
                AlertService.error(
                    error.response?.data?.message||
                    this.$t('boost.error')||
                    'Erreur lors du boost'
                );
            }
        },
        openBoostMenu() {
            console.log('openBoostMenu button clicked');
            this.showBoostMenu=true;
        },
    }
};
</script>

<style scoped>
.container-fluid-manege {
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
    margin-right: auto;
    margin-left: auto;
}

.product-management {
    margin-top: 20px;
    min-height: 100vh;
    background-color: var(--light);
}

.bottom-spacer {
    height: 20px;
}

@media (max-width: 768px) {
    .product-management {
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>
